var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Client',{attrs:{"mode":_vm.mode}})
}
var staticRenderFns = []

export { render, staticRenderFns }